import React, { Component } from 'react';
import Avatar from 'material-ui/Avatar';
import {List, ListItem} from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';
import CommunicationChatBubble from 'material-ui/svg-icons/communication/chat-bubble';
import Queue from 'material-ui/svg-icons/av/queue'
import { Grid, Row, Col } from 'react-bootstrap';
import {Card, CardActions, CardHeader, CardText, CardMedia } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField'
import { connect } from 'react-redux';
import { loadUsersFromFirebase, selectUser, sendMessage } from './messenger_actions';

class Messenger extends Component {
  constructor(props) {
    super(props)
    this.state={
      new: '',
      users: {}
    }
  }

  componentDidMount() {
    this.props.loadUsersFromFirebase()
  }

  render() {
    return (
      <Grid>
        <Row>
          <Col xs={12} sm={12} md={4} lg={3} lgOffset={1}>
            <Card style={{ borderRadius: 10, height: window.innerHeight - 200, overflow: 'scroll' }}>
              <CardText>
                <List>
                  {
                    Object.keys(this.props.users).map(user => {
                      return (
                        <ListItem
                          primaryText={user}
                          style={{ fontSize: 15 }}
                          onClick={() => this.props.selectUser(this.props.user.uid, this.props.users[user] )}/>
                      )
                    })
                  }
                </List>
              </CardText>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8}>
              <Card style={{ borderRadius: 10, backgroundColor: '#efefef', height: window.innerHeight - 200 }}>
                <CardText>
                    <Card style={{ borderRadius: 10, backgroundColor:'white', height: window.innerHeight - 300, overflow: 'scroll'}}>
                      <CardText>
                        {
                          !this.props.messages?
                           <p> No Messages</p> :
                          Object.values(this.props.messages).map(message => {
                            if (message.user._id === this.props.user.uid) {
                              return (
                                <p style={{ textAlign: 'right'}}>{message.text}</p>
                              )
                            } else {
                              return (
                                <p>{message.text}</p>
                              )
                            }
                          })
                        }
                      </CardText>
                    </Card>
                    <Col xs={10}>
                      <TextField
                        hintText="Full width"
                        fullWidth={true}
                        onChange={(e) => this.setState({ newMessage: e.target.value })}
                      />
                    </Col>
                    <Col xs={2}>
                    <RaisedButton label={'Send'} primary style={{ margin: 12 }} onClick={()=>this.props.sendMessage(this.state.newMessage,this.props.user.uid, this.props.recipient)}/>
                    </Col>
                </CardText>

              </Card>
          </Col>
        </Row>
      </Grid>
    )
  }

}


const mapStateToProps = ({messenger, auth}) => {
  const { users, messages, recipient }  = messenger;
  const {user} = auth
  return { users, messages, recipient, user };
};

export default connect(mapStateToProps,{ loadUsersFromFirebase, selectUser, sendMessage })(Messenger);



// WEBPACK FOOTER //
// ./src/components/messenger/messenger.js